<ksg-app-layout
  [sections]="sections()"
  [activeUrl]="activeUrl()"
  storageKey="master-sidebar-collapsed"
  [sidebarAriaLabel]="'topbar.mainNav' | transloco"
  [sidebarCollapseLabel]="'topbar.collapseMenu' | transloco"
  [sidebarExpandLabel]="'topbar.expandMenu' | transloco"
>
  <ksg-topbar
    appTopbar
    showMenuButton
    [menuButtonLabel]="'topbar.toggleMenu' | transloco"
  >
    <a
      topbarStart
      class="app-brand"
      routerLink="/"
      [attr.aria-label]="'topbar.home' | transloco"
    >
      <svg
        class="app-brand__logo"
        viewBox="0 0 109.73 22"
        aria-hidden="true"
        focusable="false"
      >
        <path class="app-brand__mark" d="M0 2H11L15 4L11 6H0Z"></path>
        <path
          class="app-brand__mark app-brand__mark--accent"
          d="M0 9H18L22 11L18 13H0Z"
        ></path>
        <path class="app-brand__mark" d="M0 16H7L11 18L7 20H0Z"></path>
        <text
          class="app-brand__word"
          x="28"
          y="15.851"
          font-size="13.86"
          letter-spacing="-0.3604"
        >
          Księgowskaz
        </text>
      </svg>
      <span class="app-brand__name">Master</span>
    </a>

    <ng-container topbarEnd>
      <ksg-session-timer
        [active]="auth.isAuthenticated()"
        [remainingSeconds]="session.remainingSeconds()"
        [isWarning]="session.isWarning()"
        [displayTime]="session.displayTime()"
        (extend)="session.extend()"
        (logout)="auth.logout()"
      />
      <ksg-theme-toggle
        showContrast
        [toLightLabel]="'topbar.themeLight' | transloco"
        [toDarkLabel]="'topbar.themeDark' | transloco"
        [contrastLabel]="'topbar.contrast' | transloco"
      />
      <ksg-language-selector />
    </ng-container>
  </ksg-topbar>

  <ng-template appSidebarFooter let-collapsed>
    <ksg-user-panel
      [name]="'topbar.admin' | transloco"
      [role]="'topbar.adminRole' | transloco"
      [collapsed]="collapsed"
      [menuLabel]="'topbar.userMenu' | transloco"
      [logoutLabel]="'auth.logout' | transloco"
      (logout)="auth.logout()"
    />
  </ng-template>

  <app-demo-notice variant="bar" />
  <router-outlet />
</ksg-app-layout>
